import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceBookingEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import Selectbox from '../../../moreCore/UI/SelectBox/SelectBox';
import "../../../moreCore/UI/SelectBox/SelectBox";
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Button from '../../../moreCore/UI/Button/Button';
import "../../../moreCore/UI/Button/Button";


class ServiceBookingEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    

    opusId;
    booking: any = null;
    opusSubTitle: MdsLax<InstanceType<typeof Edit>>;
    opusInstrumentationCode: MdsLax<InstanceType<typeof Edit>>;
    opusTitle: MdsLax<InstanceType<typeof Edit>>;
    opusNote: MdsLax<InstanceType<typeof Edit>>;
    opusMovements: MdsLax<InstanceType<typeof Edit>>
    opusState: MdsLax<InstanceType<typeof Selectbox>>;
    selectionValue: SelectionValueEntity = null;
    _data_SelectionValues: Array<SelectionValueEntity>;

    btnAddAddress: MdsLax<InstanceType<typeof Button>>;
    //addressList = new OpusAddressList();
    addressInput: MdsLax<InstanceType<typeof HintBox>>;
    addressRelationType: MdsLax<InstanceType<typeof Selectbox>>;
    addressPrefix: MdsLax<InstanceType<typeof Edit>>;

    saveOpus() {
        this._saveOpusData();
    }

    _saveOpusData() {
        //saves Opus entity

        //let changedAddresses = this.addressList.addressListAll.filter(list => list.hasChanged === true);
        var url = window.appRoot + "OpusManagement/SaveOpusEntity";

        let data = { //: OpusEditor.OpusFormData
            entity: {
                opusId: this.opusId,
                opusTitle: this.opusTitle.getValue(),
                opusSubtitle: this.opusSubTitle.getValue(),
                opusNote: this.opusNote.getValue(),
                opusMovements: this.opusMovements.getValue(),
                opusInstrumentationCode: this.opusInstrumentationCode.getValue(),
                opusState: this.opusState.getValue(),
                //addresses: changedAddresses
            }
        };

        this.StandbyStart();

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveOpusDataResponse, data),
            lang.hitch(this, this._onSaveOpusDataError, data),
            false // sync
        );
    }

    _onSaveOpusDataResponse(response: any) {
        this.StandbyStop();
        this.emit("saveComplete");
    }

    _onSaveOpusDataError(err: more.requestErrorMessage) {
        alert("ERROR beim OpusData: " + err.Message);
    }

    _processAddressRelationTypeValues(items) {
        //set data for RelationTypeSelectbox
        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            this.addressRelationType.addOption(entity.ID, entity.description, true);
        }

        this.addressRelationType.constructOptions();

        this.addressRelationType.startup();
    }

    _processOpusStateValues(items) {
        //set data for StateSelectbox
        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            this.opusState.addOption(entity.ID, entity.description, true);
        }

        this.opusState.setBlankOption(null, this.translations["OpusFinder_PlaceholderSelectbox_State"]);

        this.opusState.constructOptions();

        this.opusState.startup();
        this.refreshSelectionValue();
    }

    refreshSelectionValue(): void {
        if (this.booking.ref_opus_status != null) {
            this.opusState.setValue(this.booking.ref_opus_status.ID, true)
        }
    }

    setDirty(isDirty: boolean) {
        this.emit("dirty", isDirty);
    }


    _onChange_OpusData() {
        this.setDirty(true);
    }

    _onChange_AddressInput() {
        this._validateAddressInput();
    }

    _validateAddressInput() {
        //check if save would be valid + enable save button
        let addressInputFlag = this.addressInput.validateInput();
        let addresRelationTypeFlag = this.addressRelationType.validateInput();

        if (addressInputFlag && addresRelationTypeFlag) {
            this.UiModder.domClass.remove(this.btnAddAddress.domNode, "w3-disabled");
        } else {
            this.UiModder.domClass.add(this.btnAddAddress.domNode, "w3-disabled");
        }
    }


    _setValues(): void {
        //set value from response
        this.opusSubTitle.setValue(this.booking.opus_subtitel_D, true);
        this.opusTitle.setValue(this.booking.opus_titel_D, true);
        this.opusNote.setValue(this.booking.note, true);
        this.opusInstrumentationCode.setValue(this.booking.instrumentation_code_1, true);
        this.opusMovements.setValue(this.booking.movements, true);
        this.opusState.setValue(this.booking.ref_opus_status.description, true);
        this._processOpusStateValues(this.booking.opusStates);
        this._processAddressRelationTypeValues(this.booking.addressRelationTypes);

        this.setDirty(false);
        
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //set Input Options
        this.opusNote.setIsMultiline(true);
        this.opusMovements.setIsMultiline(true);
        //this.addressPrefix.setPlaceholder(this.translations["OpusFinder_PlaceholderInput_Prefix"]);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceBookingEditor);